// (() => {
//   angular
//     .module('complianceFrameworkApp.socialMediaCompliance')
//     .config(routes);

//   /* ngInject */
//   function routes($stateProvider) {
//     $stateProvider
//       .state('application.social_media_compliance.company_page_posts', {
//         url: '/company_page_posts',
//         views: {
//           '@application.social_media_compliance': {
//             templateUrl: '/templates/social_media_compliance/company_page_posts/company-page-posts.html',
//             controller: 'CompanyPagePostsController',
//             controllerAs: 'vm'
//           }
//         }
//       })
//       ;
//   }
// })();
